import React from "react";
import { createUseStyles } from "react-jss";

import {
  spotify,
  anchor,
  apple,
  google,
  overcast,
  breaker,
  castbox,
  pocket,
  radioPublic,
  stitcher,
} from "../assets/icon/index";

const usePodcastStyle = createUseStyles({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "2rem",
    columnGap: "5rem",
    "& .podcast-list-title": {},
  },
  podcastWrapper: {
    display: "flex",
    justifyContent: "end",
    flexWrap: "wrap",
    rowGap: "1rem",
    columnGap: "3.25rem",
  },
  podcastItem: {
    flexShrink: 0,
    "&:before, &:after": {
      display: "none",
    },
    "& img": {
      borderRadius: "2px",
      margin: "0 !important",
      width: "28px !important",
      height: "28px",
    },
  },
});

const PODCAST_LINK = [
  {
    link: "https://open.spotify.com/show/7Hwa9esad29XBVENIGPX6y",
    icon: spotify,
    name: "Spotify",
  },
  {
    link: "https://podcasts.apple.com/in/podcast/sunny-side-up-podcast/id1364456198",
    icon: apple,
    name: "Apple Podcast",
  },
  {
    link: "https://www.google.com/podcasts?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy8zMDBlOTA0L3BvZGNhc3QvcnNz",
    icon: google,
    name: "Google Podcast",
  },
  {
    link: "https://www.stitcher.com/show/sunny-side-up-podcast",
    icon: stitcher,
    name: "Stitcher",
  },
  {
    link: "https://castbox.fm/channel/id1220044",
    icon: castbox,
    name: "Castbox",
  },
  {
    link: "https://anchor.fm/sunny-side-up",
    icon: anchor,
    name: "Anchor",
  },
  {
    link: "https://overcast.fm/itunes1364456198",
    icon: overcast,
    name: "Overcast",
  },
  {
    link: "http://pca.st/GnfS",
    icon: pocket,
    name: "Pocket Casts",
  },
  {
    link: "https://play.radiopublic.com/sunny-side-up-G1aDrE",
    icon: radioPublic,
    name: "Radio Public",
  },
  {
    link: "https://www.breaker.audio/sunny-side-up-1",
    icon: breaker,
    name: "Breaker",
  },
];

const Podcast = () => {
  const classes = usePodcastStyle();

  return (
    <div className={classes.container}>
      <p className="podcast-list-title">Subscribe and Listen</p>
      <div className={classes.podcastWrapper}>
        {PODCAST_LINK.map((podcast) => {
          return (
            <a
              key={podcast.name}
              className={classes.podcastItem}
              title={podcast.name}
              href={podcast.link}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="podcast-image"
                src={podcast.icon}
                alt={podcast.name}
                width={28}
                height={28}
              />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default Podcast;
